import Default from "./SimpleExpander";
export * from "./SimpleExpander";
export default Default;
